import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess("");

    try {
      await addDoc(collection(db, "messages"), {
        name,
        email,
        message,
        timestamp: serverTimestamp(),
      });
      setSuccess("✅ Message sent successfully!");
      setName("");
      setEmail("");
      setMessage("");
    } catch (err) {
      console.error("Error sending message:", err);
      // Prevents “unknown promise rejection”
      setSuccess("❌ Failed to send message. Try again. " + (err.message || ""));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen text-white bg-gradient-to-b from-gray-900 via-purple-900 to-black relative">
      <Navbar />

      <div
        className="absolute inset-0 bg-cover bg-center opacity-20 z-0"
        style={{ backgroundImage: 'url("/nails.jpeg")' }}
      ></div>

      <main className="relative z-10 flex-grow flex flex-col items-center justify-start pt-24 px-4">
        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-8 shadow-lg w-full max-w-2xl text-center">
          <h2 className="text-3xl font-bold text-pink-400 mb-4">Contact Us</h2>
          <p className="text-white/80 mb-6">Got questions or feedback? Send us a message below.</p>

          <form onSubmit={handleSubmit} className="space-y-4 text-left">
            <input
              type="text"
              placeholder="Your Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="w-full px-4 py-2 rounded-md bg-black/40 border border-white/30 text-white focus:outline-none focus:ring-2 focus:ring-pink-400"
            />
            <input
              type="email"
              placeholder="Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-2 rounded-md bg-black/40 border border-white/30 text-white focus:outline-none focus:ring-2 focus:ring-pink-400"
            />
            <textarea
              placeholder="Your Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              rows="4"
              className="w-full px-4 py-2 rounded-md bg-black/40 border border-white/30 text-white focus:outline-none focus:ring-2 focus:ring-pink-400"
            />
            <button
              type="submit"
              disabled={loading}
              className="w-full py-2 bg-pink-500 text-white rounded-lg hover:bg-pink-600 transition disabled:opacity-50"
            >
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>

          {success && <p className="mt-4 text-sm">{success}</p>}
        </div>
      </main>

      <Footer />
    </div>
  );
}
